<template>
	<div id="sites-panel" class="container panel">
		<div class="row">
			<div class="col-md-3 sidebar">
				<side-bar mode="settings"></side-bar>
			</div>

			<div class="col-md-9 content">
				<dash-head class="mb-3" :title="title" subtitle="Password Security Portal"></dash-head>		

				<div v-if="!showAddSite">
					<table-actions placeholder="search results" hideSearch="true" hideEdit="true"  hideDelete="true">
					</table-actions>
					<table-view id="sites-results">
						<table-row slot="header">
							<table-header class="headerSortDown2">Site Id</table-header>
							<table-header>Description</table-header>
						</table-row>
						<table-row slot="body" v-for="result in results" :key="result.partitionKey">
							<table-cell>{{result.partitionKey}}</table-cell>
							<table-cell>{{result.rowKey}}</table-cell>
						</table-row>
					</table-view>

					<div class="row">
						<div class="col-md-6">
							<table-pagination ref="tablePagination" :page="1" :total="totalRows" :pageSize="pageSize" @page-changed="pageChanged"></table-pagination>
						</div>
						<div class="col-md-6">
							<div class="text-right">
								<button class="btn btn-outline-primary px-3" @click.prevent="showHideAddSite(true)">Add Site</button>
							</div>
						</div>			
					</div>
				</div>
			
				<div v-if="showAddSite">
					<hr class="mt-3 mb-3">
					<add-site-form :site="newSiteId" @close-add-site="showHideAddSite(false)"></add-site-form>
				</div>

			</div>
		</div>	
	</div>
</template>

<script>
	import SideBar from './SideBar'
	import DashHead from './DashHead'
	import TableActions from './TableActions'
	import TableView from './TableView'
	import TableRow from './TableRow'
	import TableHeader from './TableHeader'
	import TableCell from './TableCell'
	import TablePagination from './TablePagination'
	import AddSiteForm from './AddSiteForm'

	import api from '../api'
	import router from '../router'
	import store from '../state'

	export default {
		name: 'SitesPanel',
		props: ['pageSize'],
		components: {SideBar, DashHead, TableActions, TableView, TableRow, TableHeader, TableCell, TablePagination, AddSiteForm},
		data() {
			return {
				title: 'Sites',
				totalRows: 0,
				results: null,
				loadingData: false,
				data: null,
				error: null,
				resultFound: null,
				checkedRows: [],
				showAddSite: false
			}
		},
		methods: {
			showHideAddSite(value) {
				this.title = (value) ? 'Add Site' : 'Sites';
				this.showAddSite = value;

				//Reload
				if (!this.showAddSite) this.getSites();
			},
			pageChanged(value) {
				const start = (value-1) * this.pageSize;		
				
				this.results = [];								

				for (var result of this.data.slice(start, start + this.pageSize)) {				
					this.results.push(result);
				}							
			},
			async getSites() {
				try
				{
					const response = await api.get(`system/sites`);					
					this.data = response.data;

					//Sort data by Site id numeric
					response.data.sort((a,b) => a.partitionKey - b.partitionKey);

					this.totalRows = response.data.length;
					this.pageChanged(1);
				}
				catch(err) {
					this.error = err + ""; //Get the string representation of the error		
				}
			}
		},
		mounted() {
			this.getSites();
		},
		computed: {
			newSiteId() {
				//Results are sorted, so get last and add one
				if (!this.data) return 0;
				return  parseInt(this.data[this.data.length-1].partitionKey) + 1;
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/SitesPanel.vue